export { default } from '@/features/settings/pages/EditPrinterPage'
